/** @format */

import {
  fetchTopCities,
  fetchStates,
  fetchCities,
  fetchCountries,
} from "../Components/techrelevance.apis/fetchSalaryRange";
import React from "react";
import { Grid, Box, Chip } from "@mui/material";
import {
  setUserState,
  setUserTopCities,
  setUserCountry,
  setUserStateList,
  setSalaryRangeSkeleton,
  setCountryList,
  setUserExperienceRange,
  setUserCity,
} from "../redux/action/userLocation";

const callBackUrl = (callBack, isParams, referralUrl) => {
  const isLocalhost = window.location.hostname === "localhost";

  // if (callBack === "signIn") {
  //   if (isLocalhost) {
  //     if (isParams === referralUrl) {
  //       return "http://localhost:3000/endorse-expertise";
  //     } else {
  //       return `http://localhost:3000${isParams}`;
  //     }
  //   } else {
  //     if (isParams === referralUrl) {
  //       return "https://master.d3hqz1cwjn0bmv.amplifyapp.com/endorse-expertise";
  //     } else {
  //       return `https://master.d3hqz1cwjn0bmv.amplifyapp.com${isParams}`;
  //     }
  //   }
  // } else {
  if (isLocalhost) {
    return "http://localhost:3000/skill-relevance";
  } else {
    return `https://master.career.trueselfy.com/skill-relevance`;
  }
  // }
};

const callBackUrlSignOut = (callBack, isParams, referralUrl) => {
  const isLocalhost = window.location.hostname === "localhost";

  // if (callBack === "signIn") {
  //   if (isLocalhost) {
  //     if (isParams === referralUrl) {
  //       return "http://localhost:3000/endorse-expertise";
  //     } else {
  //       return `http://localhost:3000${isParams}`;
  //     }
  //   } else {
  //     if (isParams === referralUrl) {
  //       return "https://master.d3hqz1cwjn0bmv.amplifyapp.com/endorse-expertise";
  //     } else {
  //       return `https://master.d3hqz1cwjn0bmv.amplifyapp.com${isParams}`;
  //     }
  //   }
  // } else {
  if (isLocalhost) {
    return "http://localhost:3000";
  } else {
    return `https://master.career.trueselfy.com`;
  }
  // }
};

export const getRedirectSignInURL = () => {
  sessionStorage.setItem("userType", "auth-user");
  const REACT_APP_ENV = process.env.REACT_APP_ENV;
  // const urlSearchString = window.location.search;
  // const params = new URLSearchParams(urlSearchString);
  // const redirectLink = params.get("link");
  // if (redirectLink === "/endorse-expertise") {
  //   saveTargetPath(redirectLink);
  // }
  // const isParams = getTargetPath();
  // const referralUrl = "/endorse-expertise";
  switch (REACT_APP_ENV) {
    case "dev":
      return callBackUrl();
    case "test":
      return "https://test.career.trueselfy.com/skill-relevance";
    case "prod":
      return "https://www.career.trueselfy.com/skill-relevance";
    default:
      return "https://www.career.trueselfy.com/skill-relevance";
  }
};

export const getRedirectSignOutURL = () => {
  const REACT_APP_ENV = process.env.REACT_APP_ENV;
  switch (REACT_APP_ENV) {
    case "dev":
      return callBackUrlSignOut();
    case "test":
      return "https://test.career.trueselfy.com";
    case "prod":
      return "https://www.career.trueselfy.com";
    default:
      return "https://www.career.trueselfy.com";
  }
};

export function GetBackGroundColor(skillDemand, type) {
  if (skillDemand === "Trending") {
    switch (type) {
      case "y":
        return "#278C37";
      case "tech":
        return "#278C37";
      case "mgmt":
        return "#30B044";
      case "management":
        return "#30B044";
      case "generic":
        return "#38C94E";
      default:
        return "#278C37";
    }
  }
  if (skillDemand === "Obsolete") {
    switch (type) {
      case "y":
        return "#028EDF";
      case "tech":
        return "#028EDF";
      case "mgmt":
        return "#09A2FA";
      case "management":
        return "#09A2FA";
      case "generic":
        return "#79CDFD";
      default:
        return "#028EDF";
    }
  }
  if (skillDemand === "In demand") {
    switch (type) {
      case "y":
        return "#E9B112";
      case "tech":
        return "#E9B112";
      case "mgmt":
        return "#FEC113";
      case "management":
        return "#FEC113";
      case "generic":
        return "#FAD15D";
      default:
        return "#E9B112";
    }
  }
  if (skillDemand === "Getting outdated fast") {
    switch (type) {
      case "y":
        return "#C60015";
      case "tech":
        return "#C60015";
      case "mgmt":
        return "#E2031B";
      case "management":
        return "#E2031B";
      case "generic":
        return "#FF465A";
      default:
        return "#C60015";
    }
  }
}

export function checkYearWithGpt(option) {
  const year = option?.expiryYear;
  const currentYear = new Date().getFullYear();
  const minYearDiff = 5;
  const minYearForOutdatedSkill = 4;
  const minYearForCurrentSkill = 1;

  if (!year) {
    return {
      label: "Default",
      barPrimaryColor: "#e0e0e0",
      barSecondaryColor: "#e0e0e0",
    };
  }

  if (year > currentYear) {
    if (option?.chat_gpt === false && option?.estYear === 2010) {
      return {
        label: `Obsolete`,
        barPrimaryColor: "red",
        // barSecondaryColor: "#FFCDD2",
        barSecondaryColor: GetBackGroundColor("Obsolete", option?.type),
        // color: "red",
        color: "#4fb7f7",
      };
    } else {
      return {
        label: `Trending`,
        barPrimaryColor: "green",
        // barSecondaryColor: "#A5D6A7",
        barSecondaryColor: GetBackGroundColor("Trending", option?.type),

        // color: "#26801E",
        color: "#58f374",
      };
    }
  } else if (year >= currentYear - minYearForCurrentSkill) {
    return {
      label: `In demand`,
      barPrimaryColor: "darkorange",
      // barSecondaryColor: "#ffcc80",
      barSecondaryColor: GetBackGroundColor("In demand", option?.type),
      // color: "darkorange",
      color: "#ffd560",
    };
  } else if (year >= currentYear - minYearForOutdatedSkill) {
    return {
      label: `Getting outdated fast`,
      barPrimaryColor: "#ffc107",
      // barSecondaryColor: "#fff59d",
      barSecondaryColor: GetBackGroundColor(
        `Getting outdated fast`,
        option?.type
      ),

      // color: "#FF9D09",
      color: "#f74861",
    };
  } else if (year <= currentYear - minYearDiff) {
    return {
      label: `Obsolete `,
      barPrimaryColor: "red",
      // barSecondaryColor: "#FFCDD2",
      barSecondaryColor: GetBackGroundColor(`Obsolete`, option?.type),
      // color: "red",
      color: "#4fb7f7",
    };
  }
}

function checkYear(year) {
  const currentYear = new Date().getFullYear();
  const minYearDiff = 5;
  const minYearForOutdatedSkill = 4;
  const minYearForCurrentSkill = 1;

  if (year > currentYear) {
    return {
      label: `Trending `,
      barPrimaryColor: "green",
      // barSecondaryColor: "#A5D6A7",
      barSecondaryColor: "#278C37",

      // color: "#26801E",
      color: "#58f374",
    };
  } else if (year >= currentYear - minYearForCurrentSkill) {
    return {
      label: ` In demand`,
      barPrimaryColor: "darkorange",
      // barSecondaryColor: "#ffcc80",
      barSecondaryColor: "#E9B112",
      // color: "darkorange",
      color: "#ffd560",
    };
  } else if (year >= currentYear - minYearForOutdatedSkill) {
    return {
      label: `Getting outdated fast`,
      barPrimaryColor: "#ffc107",
      // barSecondaryColor: "#fff59d",
      barSecondaryColor: "#C60015",

      // color: "#FF9D09",
      color: "#f74861",
    };
  } else if (year <= currentYear - minYearDiff) {
    return {
      label: `Obsolete `,
      barPrimaryColor: "red",
      // barSecondaryColor: "#FFCDD2",
      barSecondaryColor: "#028EDF",

      // color: "red",
      color: "#4fb7f7",
    };
  }
}

export const Legend = () => {
  const currentYear = new Date().getFullYear();
  const years = [
    currentYear + 1,
    currentYear,
    currentYear - 2,
    currentYear - 6,
  ];

  return (
    <Grid container spacing={1} sx={{ mb: 2 }}>
      {/* <Grid item>
        <Chip
          label={`Searching...`}
          // className={year > currentYear ? "shine-effect" : ""}
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            color: "rgba(0, 0, 0, 0.87)",
            border: "1px solid rgba(0, 0, 0, 0.36)",
            fontWeight: 600,
          }}
        />
      </Grid> */}
      {years.map((year, index) => {
        const yearInfo = checkYear(year);
        return (
          <Grid item key={index}>
            <Chip
              label={yearInfo.label}
              // className={year > currentYear ? "shine-effect" : ""}
              sx={{
                backgroundColor: yearInfo?.barSecondaryColor,
                color: "#fff" || "rgba(0, 0, 0, 0.87)",
                border: `1px solid ${yearInfo.color}`,
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
export const retry = async (fn, retries = 2, delay = 500) => {
  let lastError;
  for (let i = 0; i <= retries; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (i < retries) await new Promise((res) => setTimeout(res, delay));
    }
  }
  throw lastError;
};

export const getTopCitiesList = async (country, state, dispatch) => {
  return retry(async () => {
    const { cities } = await fetchTopCities(country, state);
    dispatch(setUserState(state));
    dispatch(setUserTopCities(cities));
  }).catch((error) => {
    console.error("Failed to fetch top cities after retries:", error);
  });
};

export const getStatesList = async (
  countryName,
  countries,
  dispatch,
  address,
  stateList
) => {
  if (countries && countries.length && stateList && stateList.length) {
    // console.log("Using cached states and countries");
    return;
  }

  return retry(async () => {
    const findElm = countryName.trim().toLowerCase();
    const countryInstance = countries.find(
      (c) => c.name.toLowerCase() === findElm
    );

    if (!countryInstance) {
      throw new Error("Country not found: " + findElm);
    }

    const { states } = await fetchStates(countryInstance);

    dispatch(setUserCountry(countryInstance));
    dispatch(setUserStateList(states));
    const state = states.find(
      (s) => s.name.toLowerCase() === address.state?.toLowerCase().trim()
    ) || {
      name: address.state || "Unknown",
      countryShortName: countryInstance.shortName,
    };
    dispatch(setUserState(state));
    fetchCities(state, dispatch);
    await getTopCitiesList(countryInstance, state);
    dispatch(setSalaryRangeSkeleton(false));
  }).catch((error) => {
    console.error("Failed to fetch states after retries:", error);
    dispatch(setUserCountry({ name: "India", shortName: "IN" }));
  });
};

export const getCountriesList = async (
  dispatch,
  address,
  countries,
  stateList,
  userExperienceRange
) => {
  // if (
  //   countries &&
  //   countries.length &&
  //   userExperienceRange &&
  //   userExperienceRange.length &&
  //   stateList &&
  //   stateList.length
  // ) {
  //   return;
  // }

  return retry(async () => {
    dispatch(setSalaryRangeSkeleton(true));

    const { countries: fetchedCountries, experienceRange } =
      await fetchCountries();
    const userCountry = address.country || "United States";
    dispatch(setCountryList(fetchedCountries));
    dispatch(setUserExperienceRange(experienceRange));

    await getStatesList(userCountry, fetchedCountries, dispatch, address);

    const countryInstance = fetchedCountries.find(
      (s) => s.name.toLowerCase() === address.country?.toLowerCase().trim()
    ) || { name: "United States", shortName: "US" };
    // const userState = {
    //   name: countryInstance.capitalState,
    //   stateCode: countryInstance.stateCode,
    // };
    // dispatch(setUserState(userState));
    const cityInstance = {
      name: address.city || "Unknown",
      countryShortName: countryInstance.shortName,
    };

    dispatch(setUserCountry(countryInstance));
    dispatch(setUserCity(cityInstance));
  }).catch((error) => {
    console.error("Failed to fetch countries after retries:", error);
  });
};

export const getIconBySkillName = (imgPath, skillName) => {
  return imgPath && imgPath.trim() !== ""
    ? `../../../assets/images/${imgPath}`
    : null;
};
